@if (selectedClient) {
	<nz-table #licenseTable [nzData]="licenses" [nzLoading]="licenseService.loading$ | async" [nzNoResult]="noData">
		<thead>
			<tr>
				<th>Product Name</th>
				<th>License Type</th>
				<th>License ID</th>
				<th>Count</th>
				<th>Start Date</th>
				<th>End Date</th>
			</tr>
		</thead>
		<tbody>
			@for (license of licenses; track license) {
				<tr>
					<td>{{ license.product_name }}</td>
					<td>{{ license.license_type }}</td>
					<td>{{ license.license_id }}</td>
					<td>{{ license.count }}</td>
					<td>{{ license.start_date | date: 'mediumDate' }}</td>
					<td>{{ license.end_date | date: 'mediumDate' }}</td>
				</tr>
			}
		</tbody>
		<ng-template #noData>
			<nz-typography>No licenses available</nz-typography>
		</ng-template>
	</nz-table>
}
